import TranslationService from "ceres/app/services/TranslationService";
import Vue from "vue";
import { mapState } from "vuex";
import { isDefined } from "ceres/app/helper/utils";

const NotificationService = require("ceres/app/services/NotificationService");

import { makeProductArray } from "~/app/helper/DataLayer";

export default Vue.component("payment-provider-select", {
    props: {
        template: {
            type: String, default: "#vue-payment-provider-select"
        }, paddingClasses: {
            type: String, default: null
        }, paddingInlineStyles: {
            type: String, default: null
        }
    },

    data() {
        return {
            trackPaymentMethod: false
        };
    },

    computed: mapState({
        methodOfPaymentList: state => state.checkout.payment.methodOfPaymentList,
        methodOfPaymentId: state => state.checkout.payment.methodOfPaymentId,
        showError: state => state.checkout.validation.paymentProvider.showError,
        isBasketLoading: state => state.basket.isBasketLoading,
        isCheckoutReadonly: state => state.checkout.readOnly,
        selectedShippingProfile: state => state.checkout.shipping.selectedShippingProfile,
        basketItems: state => state.basket.items
    }),

    /**
     * Initialise the event listener
     */
    created() {
        this.$store.commit("setPaymentProviderValidator", this.validate);

        document.addEventListener("afterPaymentMethodChanged", event => {
            if (this.trackPaymentMethod) {

                let paymentMethod = {
                    name: ""
                };

                for (const key in this.methodOfPaymentList) {
                    if (this.methodOfPaymentList[key].id === event.detail) {
                        paymentMethod = this.methodOfPaymentList[key];
                    }
                }

                dataLayer.push({
                    "event": "EE_Checkout_Payment", "ecommerce": {
                        "checkout": {
                            "actionField": { "step": 3, "option": paymentMethod.name },
                            "products": makeProductArray(this.basketItems)
                        }
                    }
                });
            } else {
                this.trackPaymentMethod = true;
            }
        });
    },

    methods: {
        /**
         * Event when changing the payment provider
         */
        onPaymentProviderChange(newMethodOfPayment) {
            this.$store.dispatch("selectMethodOfPayment", newMethodOfPayment.id)
                .then(data => {
                    this.trackPaymentMethod = false;
                    document.dispatchEvent(new CustomEvent("afterPaymentMethodChanged", { detail: this.methodOfPaymentId }));
                }, error => {
                    console.log("error");
                });

            this.validate();
        },

        validate() {
            const showError = !(this.methodOfPaymentId > 0);

            this.$store.commit("setPaymentProviderShowError", showError);

            if (showError) {
                NotificationService.error(TranslationService.translate("Ceres::Template.checkoutCheckPaymentProvider"));
            }
        },

        isPaymentMethodExcluded(paymentMethodId) {
            if (isDefined(this.selectedShippingProfile?.excludedPaymentMethodIds)) {
                return this.selectedShippingProfile.excludedPaymentMethodIds.includes(paymentMethodId);
            } else {
                return false;
            }
        }
    }
});
